import { render } from "./DashboardManager.vue?vue&type=template&id=0efa1e76&scoped=true"
import script from "./DashboardManager.vue?vue&type=script&lang=js"
export * from "./DashboardManager.vue?vue&type=script&lang=js"

import "./DashboardManager.vue?vue&type=style&index=0&id=0efa1e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efa1e76"]])

export default __exports__